import React from 'react';

interface CardFooterProps {
  cardType: 'video' | 'module' | 'assessment' | string;
  completionPercentage: string | number;
  count: number;
  isAssessment?: boolean;
}

export default function CardFooter({
  cardType,
  completionPercentage,
  count,
  isAssessment,
}: CardFooterProps) {
  const isVideo = cardType === 'video';
  const formattedCompletion = `${completionPercentage}%`;

  return (
    <div className="card-footer">
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
        }}
      >
        {isAssessment ? (
          <div
            style={{
              fontSize: isVideo ? 14 : 18,
              fontWeight: 600,
              textAlign: 'center',
              margin: 'auto',
              height: '100%',
            }}
          >
            Assessment
          </div>
        ) : (
          <>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 18, fontWeight: 600 }}>{count}</div>
              <div
                style={{
                  fontSize: 12,
                  fontWeight: 500,
                  color: 'gray',
                  textTransform: 'capitalize',
                }}
              >
                {cardType}
              </div>
            </div>

            <div style={{ textAlign: 'center', minWidth: 60 }}>
              <div
                style={{
                  fontSize: isVideo ? 14 : 18,
                  fontWeight: 600,
                }}
              >
                {formattedCompletion}
              </div>
              {!isVideo && (
                <div style={{ fontSize: 12, color: 'gray', fontWeight: 500 }}>
                  Complete
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
